import { render, staticRenderFns } from "./OrderReportMess.vue?vue&type=template&id=0e97c570&scoped=true"
import script from "./OrderReportMess.vue?vue&type=script&lang=js"
export * from "./OrderReportMess.vue?vue&type=script&lang=js"
import style0 from "./OrderReportMess.vue?vue&type=style&index=0&id=0e97c570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e97c570",
  null
  
)

export default component.exports